import styled from "styled-components";

import {ChevronUp} from "lucide-react";
import Button from "./button";

const ScrollToTop = styled(({onClick, className}) =>
    <Button className={className} onClick={onClick}>
        <ChevronUp size={24} />
    </Button>
)`
  display: none;
  position: fixed;
  bottom: 68px;
  right: 20px;
  padding: 0;
  height: 48px;
  align-items: center;
  justify-content: center;
  width: 48px;
  opacity: 0.5;
  border-radius: 50%;
  background-color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : theme.blue_1};
  color: ${({theme}) => theme.color.name === 'dark' ? theme.blue_1 : theme.white_0};
`;

export default ScrollToTop;
